/* global dataLayer */
import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="newsletter-captador"
// Captador de newsletter del lateral de los blogs (ENH-RNK-3733, ENH-RNK-6325).
// Intercepta el submit, lo envía por fetch (POST, doble opt-in diferido) y sustituye el
// formulario por el mensaje de confirmación SIN navegar, para no sacar al lector del
// artículo. El alta real ocurre cuando el lector pulsa el enlace del email de confirmación.
export default class extends Controller {
  static targets = ['form']
  static values = { tematica: String }

  connect () {
    this.formTarget.addEventListener('submit', (event) => {
      event.preventDefault()
      this.suscribir()
    })
  }

  suscribir () {
    const form = this.formTarget
    if (!form.reportValidity()) return

    // POST y no GET: con el email en la query acababa en logs y en GA4 (auditoría de analítica, H01).
    // El FormData lleva el authenticity_token del formulario.
    const datos = new FormData(form)
    const params = new URLSearchParams(datos)
    fetch(form.action, { method: 'POST', body: datos, headers: { Accept: 'application/json' } })
      .then(response => response.json().then(data => ({ ok: response.ok, data })))
      .then(({ ok, data }) => {
        if (ok && data.status === 'ok') this.notificarEnvio(params)
        this.mostrarMensaje(ok, data)
      })
      .catch(() => this.mostrarMensaje(false, {}))
  }

  mostrarMensaje (ok, data) {
    if (ok && data.status === 'ok') {
      this.reemplazarFormulario('rnk-Flash-success', 'Te hemos enviado un email para confirmar tu suscripción. Revisa tu bandeja de entrada para completarla.')
    } else if (ok && data.status === 'ya_suscrito') {
      this.reemplazarFormulario('rnk-Flash-info', 'Ya estabas suscrito a esta newsletter.')
    } else {
      this.mostrarError(data.error || 'No hemos podido procesar tu suscripción. Revisa el email e inténtalo de nuevo.')
    }
  }

  // Evento para GA4 vía GTM (Trello #2089): el envío va por fetch, así que GA4 no ve ninguna
  // página. Mide solicitudes con email enviado, no altas: el alta llega al confirmar el email.
  // Guard sobre `dataLayer`: sin GTM (local, bloqueadores) no debe romper el mensaje.
  notificarEnvio (params) {
    if (typeof dataLayer === 'undefined') return

    dataLayer.push({
      event: 'newsletter_signup',
      tematica: this.tematicaValue,
      cta_tipo: params.get('cta_tipo'),
      cta_subtipo: params.get('cta_subtipo'),
      page_path: window.location.pathname
    })
  }

  reemplazarFormulario (estilo, texto) {
    // Limpia un posible error de un intento anterior para no mostrarlo junto al mensaje de éxito.
    this.element.querySelector('.rnk-NewsletterCaptador_Error')?.remove()
    const mensaje = document.createElement('div')
    mensaje.className = estilo
    mensaje.textContent = texto
    this.formTarget.replaceWith(mensaje)
  }

  // En caso de fallo transitorio se conserva el formulario para poder reintentar; el error
  // se muestra una sola vez, reemplazando el de un intento anterior si lo hubiera.
  mostrarError (texto) {
    this.element.querySelector('.rnk-NewsletterCaptador_Error')?.remove()
    const error = document.createElement('div')
    error.className = 'rnk-Flash-danger rnk-NewsletterCaptador_Error'
    error.textContent = texto
    this.formTarget.insertAdjacentElement('afterend', error)
  }
}
